const usCountryCode = '1';

function phoneDigits(value: string) {
  return value.replace(/\D/g, '');
}

export function normalizeUsPhoneNumber(value: string) {
  const trimmed = value.trim();
  const digits = phoneDigits(trimmed);

  if (!digits) {
    return null;
  }

  if (trimmed.startsWith('+')) {
    return digits.length === 11 && digits.startsWith(usCountryCode)
      ? `+${digits}`
      : null;
  }

  if (digits.length === 10) {
    return `+${usCountryCode}${digits}`;
  }

  if (digits.length === 11 && digits.startsWith(usCountryCode)) {
    return `+${digits}`;
  }

  return null;
}

export function formatUsPhoneNumberInput(value: string) {
  const digits = phoneDigits(value).slice(0, 11);
  const nationalDigits =
    digits.length > 10 && digits.startsWith(usCountryCode)
      ? digits.slice(1)
      : digits.slice(0, 10);

  if (nationalDigits.length <= 3) {
    return nationalDigits;
  }

  if (nationalDigits.length <= 6) {
    return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3)}`;
  }

  return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(
    3,
    6,
  )}-${nationalDigits.slice(6)}`;
}

export function formatUsPhoneNumberDisplay(value: string | null | undefined) {
  if (!value) {
    return '';
  }

  return formatUsPhoneNumberInput(value);
}

export function phoneNumberMatchesStoredPhone(
  value: string,
  storedPhone: string | null | undefined,
) {
  const normalizedValue = normalizeUsPhoneNumber(value);

  return Boolean(normalizedValue && storedPhone && normalizedValue === storedPhone);
}
